import styled from 'styled-components';

export const AssetModalSidebarHeader = styled.div`
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--cc_size_spacing_s) var(--cc_size_spacing_l);
  background: var(--cc_color_background_2);
  color: var(--cc_color_text_default);
  font-family: 'Averta', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-weight: 600;
  line-height: 1.25;
  font-size: var(--cc_size_text_s);
`;